export default function Stock() {
  return (
    <section className="sales-layout__page">
      <h1>Lager</h1>
      <p>Wählen Sie einen Untermenüpunkt aus.</p>
    </section>
  );
}
